module.exports = __webpack_public_path__ + "static/media/light.959c2305.png";